module.exports = __webpack_public_path__ + "de59a97248b44599e6747a27a943f738.woff2";